import {get} from '../../utils'
import {load} from '../../apis/persist'
import {actionTypes} from '../actions/outlet'
import {getInitialFromQuery} from '../utils'

const canShowResultsReducer = (
  {
    nameplate, dealerConfirm, dealer = {}, results, isFetchingStock,
  },
  payload,
) =>
  (get('fetched', dealer) && nameplate
    ? (results && results.length > 0 && dealerConfirm) || isFetchingStock
    : false)

const stepChangeReducer = ({dealer, nameplate, canShowResults}, {step}) => {
  switch(step) {
    case 'SELECT_DEALER':
      break
    case 'SELECT_NAMEPLATE':
      if (!dealer || !dealer.fetched) return 'SELECT_DEALER'
      if (!nameplate) return 'SELECT_NAMEPLATE'
      break
    case 'SHOW_RESULTS':
      if (!dealer || !dealer.fetched) return 'SELECT_DEALER'
      if (!nameplate) return 'SELECT_NAMEPLATE'
      if (!canShowResults) return 'SELECT_NAMEPLATE'
      break
    default:
      return step
  }
  return step
}

const queryDealer = getInitialFromQuery('dealerCode')
const queryLocationId = getInitialFromQuery('locationId')

const initialState = {
  step: 'SELECT_DEALER',
  storeLoading: true,
  previousDealer: getInitialFromQuery('previousDealer') || '',
  nameplate: getInitialFromQuery('nameplate'),
  isFetchingDealer: false,
  isFetchingStock: false,
  canShowResults: false,
  dealerConfirm: false,
  noResultMessages: {},
  dealer:
    (queryDealer && {dealerCode: queryDealer, id: queryLocationId}) || load('localDealer') || {},
  copyMode: 'WELCOME',
  outletStockEndpoint: false,
  fetchError: '',
  results: [],
  availability: [],
  sort: {key: 'storeType', dir: 'DESC'},
  filter: ['DEMO', 'RUNOUT'],
}

export default function outlet(state = initialState, {type, payload} = {}) {
  switch(type) {
    case actionTypes.INIT_OUTLET_STORE:
      return {...state, ...payload, storeLoading: true}
    case actionTypes.LOAD_OUTLET_STORE:
      return {...state, ...payload, storeLoading: false}
    case actionTypes.DEALER_CHANGE_REQUEST:
      return {
        ...state,
        ...payload,
        canShowResults: canShowResultsReducer(state, payload),
      }
    case actionTypes.DEALER_CHANGE_SUCCESS:
      return {
        ...state,
        ...payload,
        canShowResults: canShowResultsReducer(state, payload),
      }
    case actionTypes.DEALER_CHANGE_NO_RESULTS:
      return {
        ...state,
        ...payload,
        canShowResults: canShowResultsReducer(state, payload),
        noResultMessages: {
          ...state.noResultMessages,
          ...payload.noResultMessage,
        },
      }
    case actionTypes.DEALER_CONFIRM:
      return {
        ...state,
        dealerConfirm: true,
      }
    case actionTypes.DEALER_RESET:
      return {
        ...state,
        previousDealer: state.dealer.name,
        dealer: false,
        dealerConfirm: false,
        availability: [],
        results: [],
      }
    case actionTypes.NAMEPLATE_CHANGE:
      return {...state, ...payload}
    case actionTypes.DEALER_FETCH_START:
      return {...state, isFetchingDealer: true}
    case actionTypes.DEALER_FETCH_SUCCESS:
      return {
        ...state, ...payload, fetchError: '', isFetchingDealer: false,
      }
    case actionTypes.DEALER_FETCH_ERROR:
      return {...state, fetchError: payload.error, isFetchingDealer: false}
    case actionTypes.DEALER_FETCH_CANNOT_RESOLVE:
      return {
        ...state,
        isFetchingDealer: false,
        canShowResults: canShowResultsReducer(state, payload),
      }
    case actionTypes.OUTLET_STOCKS_FETCH_START:
      return {...state, isFetchingStock: true}
    case actionTypes.OUTLET_STOCKS_FETCH_SUCCESS:
      return {
        ...state, ...payload, fetchError: '', isFetchingStock: false,
      }
    case actionTypes.OUTLET_STOCKS_FETCH_ERROR:
      return {...state, fetchError: payload.error, isFetchingStock: false}
    case actionTypes.STEP_CHANGE:
      const canShowResults = canShowResultsReducer(state, payload)
      return {
        ...state,
        copyMode: 'NORMAL',
        ...payload,
        canShowResults,
        step: stepChangeReducer({...state, canShowResults}, payload),
      }
    case actionTypes.UPDATE_FILTER:
      return {...state, ...payload}
    case actionTypes.UPDATE_SORT:
      return {...state, sort: {...state.sort, ...payload.sort}}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/outlet.js